export function parseQueryParam(
	query: { [key: string]: string | string[] | undefined },
	keyName: string,
): string | undefined {
	for (const [key, value] of Object.entries(query)) {
		if (key === keyName) {
			return Array.isArray(value) ? value.join(',') : value;
		}
	}

	return undefined;
}
